/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AddStudentIcon from 'icons/AddStudentIcon';

const messages = defineMessages({
  title: {id: 'navigation.add'},
});

const AddItem = () => (
  <RouteLinkItem
    iconBefore={AddStudentIcon}
    route="midas/students/add"
    title={messages.title}
  />
);

export default AddItem;
